// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './nuvem-envio.es-AR.json';
import esCL from './nuvem-envio.es-CL.json';
import esCO from './nuvem-envio.es-CO.json';
import esMX from './nuvem-envio.es-MX.json';
import ptBR from './nuvem-envio.pt-BR.json';

const nuvemEnvioTranslations: DomainTranslations = {
  name: 'nuvemEnvio',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.CHILE]: esCL,
    [Locale.COLOMBIA]: esCO,
  },
};

export default nuvemEnvioTranslations;
